// extracted by mini-css-extract-plugin
module.exports = {"root":"Accounts_root__xvJry","container":"Accounts_container__BjcYR","title":"Accounts_title__3dHSY","actionBtn":"Accounts_actionBtn__3sYhr"};